import { FeatureStyle, GEOMETRYTYPE } from "../featuretree/internal";
import { MEASUREMODE } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * Draw Linear Referenced Point Tool
 * @class DrawLRPointTool
 * @extends {Tool}
 */
export class DrawLRPointTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        // event variables
        this.mousemoveeventnr = null;
        this.mouseouteventnr = null;
        this.resetinputevent = null;
        this.finishinputevent = null;
        this._navigationaxischangedeventnr = null;
        this._measurementaxischangedeventnr = null;
        this.featurecollection = null;
        this.pointfeature = null;
        this.cont_pointfeature = null;
        this.pos = null;
        this.snap_mx = null;
        this.snap_my = null;
        this.snappedpos = null;
        this.lrVizFeature = null;
        this.lrVizCollection = null;
        this.pointpending = false;
        this.toolstate = 0;
        this.name = name;
        this.group = group;
        const highlightstyle = new FeatureStyle({
            stylename: "DrawLRPointStyle_h",
            rules: [
                {
                    filter: "",
                    symbolizer: "point",
                    params: {
                        size: 8,
                        stroke: [0, 1, 0, 1],
                    },
                },
            ],
        });
        //options - set the default values here....
        const defaultoptions = {
            layerstyle: this.toolhandler.defaultstyles.standard,
            highlightlayerstyle: highlightstyle,
            auxiliarylinestyle: this.toolhandler.defaultstyles.standard,
            finishedcbf: null,
            errorcbf: null,
            enablecbf: null,
            disablecbf: null,
            finishinput: USERINPUTTYPE.LEFTCLICK,
            resetinput: USERINPUTTYPE.RIGHTCLICK,
            resetcbf: null,
            activecursor: "crosshair",
            maxdist: 20,
            auxiliaryline: true,
            modifycursor: true,
            continousdrawcbf: null,
            snaplayer: this.toolhandler.snaplayers,
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
        //Feature-Collection for Point-Visualisation
        this.featurecollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.layerstyle, this.options.highlightlayerstyle, "mmDrawingLRToolPointCollection_internal", false);
        this.pointfeature = this.featurecollection.createFeature();
        this.pointfeature.geometry = this.pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        this.cont_pointfeature = this.featurecollection.createFeature();
        this.cont_pointfeature.geometry = this.cont_pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        //Feature-Collection for LR-Visualisation
        this.lrVizCollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.auxiliarylinestyle, null, "lrVizCollection_internal");
        this.lrVizFeature = this.lrVizCollection.createFeature();
        this.lrVizFeature.geometry = this.lrVizFeature.createGeometry(GEOMETRYTYPE.LINESTRING);
        this.type = "DrawLRPointTool";
    }
    /**
     * internal function - to activate tool call .enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this.enabled = true;
        this._SubscribeEvents();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        }
        this.fire(DrawLRPointTool.enabled, this.options["cbobject"]);
    }
    _SubscribeEvents() {
        //check if tool is enabled and events aren't already subscribed
        if (!this.enabled || this.mouseupeventnr != null)
            return;
        this.mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        if (this.options.resetinput !== undefined) {
            this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        this.mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseouteventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEOUT, this._onMouseOut, this);
        this._navigationaxischangedeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.NAVIGATION_AXISCHANGED, this._axischanged, this);
        this._measurementaxischangedeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MEASUREMENT_AXISCHANGED, this._axischanged, this);
        if (this.options.enablecbf != null) {
            this.on(DrawLRPointTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(DrawLRPointTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.on(DrawLRPointTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(DrawLRPointTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.on(DrawLRPointTool.finished, this.options.finishedcbf);
        }
        if (this.options.errorcbf != null) {
            this.on(DrawLRPointTool.error, this.options.errorcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseouteventnr);
        this.mouseouteventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.NAVIGATION_AXISCHANGED, this._navigationaxischangedeventnr);
        this._navigationaxischangedeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MEASUREMENT_AXISCHANGED, this._measurementaxischangedeventnr);
        this._measurementaxischangedeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this.resetinputevent);
        this.resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.finishinput, this.finishinputevent);
        this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        this.finishinputevent = null;
        if (this.options.enablecbf != null) {
            this.off(DrawLRPointTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(DrawLRPointTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.off(DrawLRPointTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(DrawLRPointTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.off(DrawLRPointTool.finished, this.options.finishedcbf);
        }
        if (this.options.errorcbf != null) {
            this.off(DrawLRPointTool.error, this.options.errorcbf);
        }
    }
    /**
     * internal function - to disable tool call .disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        this.enabled = false;
        this._cleanUp();
        this.reset();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle("default");
            this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        }
        this.fire(DrawLRPointTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
    }
    /**
     * internal function mousemove
     * @method _onMouseMove
     * @param evt
     * @private
     */
    _onMouseMove(evt) {
        if (this.cont_pointfeature.ishidden) {
            this.cont_pointfeature.show();
        }
        this._measureOnMouseMove(evt);
    }
    /**
     * internal function mouseout
     * @method _onMouseOut
     * @param evt
     * @private
     */
    _onMouseOut(evt) {
        this.cont_pointfeature.hide();
        this.cont_pointfeature.update(true);
    }
    /**
     * Mouse up event
     * @method _onMouseUp
     * @param evt
     * @private
     */
    _onMouseUp(evt) {
        if (evt.button > 0) {
            return;
        }
        if (evt.isDragging)
            this._measureOnMouseMove(evt);
        else
            this._finishmeasurement(evt);
    }
    /**
     * @ignore
     * Fired every time the navigation- and measurement- axis is changed.
     * @event
     * @type {string}
     */
    _axischanged(evt) {
        if (!this.pos)
            return;
        const res = this._measureAndDrawLR();
        if (res && this.toolstate === 1) {
            const { uvwCoords, aux_line } = res;
            this.fire(DrawLRPointTool.finished, this.options["cbobject"], { uvwCoords, aux_line });
        }
    }
    /**
     * calculates world coordinates from mx, my
     * @method _measureOnMouseMove
     * @param evt
     * @private
     */
    _measureOnMouseMove(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        const mousemovemeasuremode = this.scene.getMeasureModeHandler().mouseMoveMeasureMode;
        if (mousemovemeasuremode == MEASUREMODE.NONE) {
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            return;
        }
        this._checkSnaping(evt);
        if (this.snappedpos && this.snappedpos.isValid()) {
            if (this.toolstate == 0) {
                this._measureAndDrawLR();
            }
            else {
                this.cont_pointfeature.geometry.coordinates = [
                    [this.snappedpos.Easting, this.snappedpos.Northing, this.snappedpos.Height],
                ];
                this.cont_pointfeature.update(true);
            }
            return;
        }
        //make a measurepoint in mousemove measuremode
        if (this.pointpending)
            return;
        this.pointpending = true;
        this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
            this.pointpending = false;
            if (!this.enabled)
                return;
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            if (this.toolstate == 0) {
                this.pos = pos;
                this._measureAndDrawLR();
            }
            else {
                this.cont_pointfeature.geometry.coordinates = [[pos.Easting, pos.Northing, pos.Height]];
                this.cont_pointfeature.update(true);
            }
        }, () => {
            this.pointpending = false;
            if (!this.enabled)
                return;
            if (this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED ||
                this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED) {
                this.scene.getMeasureModeHandler().showMeasureModeCursor();
            }
            else if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
            }
            this.cont_pointfeature.hide();
            this.cont_pointfeature.update(true);
        }, mousemovemeasuremode);
    }
    _pos2uvw(axis) {
        // Calculate the v- and w-coordinates based on the axis and the current position
        // The u-coordinate is calculated based on the navigation axis.
        // If the axis is not a navigation axis, it will use the current navigation axis.
        // If both not applies, it will use the navigation reference axis of the axis.
        if (axis.isnavigationref) {
            return axis.xyz2uvw(this.pos.Easting, this.pos.Northing, this.pos.Height);
        }
        else if (this.scene.getLRHandler().getActiveNavigationAxis() !== null) {
            return axis.xyz2uvw(this.pos.Easting, this.pos.Northing, this.pos.Height, this.scene.getLRHandler().getActiveNavigationAxis());
        }
        else {
            const nav_axis = this.scene.getLRHandler().axisarray.filter((_axis) => {
                return (_axis.isnavigationref && _axis.name === String(axis.axis.features[0].properties.idkilometerachse));
            });
            return axis.xyz2uvw(this.pos.Easting, this.pos.Northing, this.pos.Height, nav_axis.length > 0 ? nav_axis[0] : null);
        }
    }
    _drawAuxiliaryLine(uvwCoords) {
        const coords = [
            [this.pos.Easting, this.pos.Northing, this.pos.Height],
            [uvwCoords.axpoint[0], uvwCoords.axpoint[1], this.pos.Height],
        ];
        if (Math.abs(this.pos.Height - uvwCoords.axpoint[2]) < 20) {
            coords.push([uvwCoords.axpoint[0], uvwCoords.axpoint[1], uvwCoords.axpoint[2]]);
        }
        if (this.options.auxiliaryline) {
            this.lrVizFeature.geometry.coordinates = coords;
            this.lrVizFeature.update();
        }
        this.pointfeature.geometry.coordinates = [[this.pos.Easting, this.pos.Northing, this.pos.Height]];
        this.featurecollection.update();
        return coords;
    }
    /**
     * calculates linear coordinates from world coordinates
     * @method _measurelr
     * @private
     */
    _measureAndDrawLR() {
        const theAxis = this.scene.getLRHandler().getActiveMeasurementAxis();
        if (theAxis == null) {
            this.fire(DrawLRPointTool.error, this.options["cbobject"], "No active measurement axis found");
            return;
        }
        const uvwCoords = this._pos2uvw(theAxis);
        if (uvwCoords == null) {
            this.fire(DrawLRPointTool.error, this.options["cbobject"], "no uvw coordinates");
            return;
        }
        const aux_line = this._drawAuxiliaryLine(uvwCoords);
        this.fire(DrawLRPointTool.continousdraw, this.options["cbobject"], uvwCoords);
        return { uvwCoords, aux_line };
    }
    /**
     * calcs the world coordinates and the user defined callback functions
     * @method _finishmeasurement
     * @param evt
     * @private
     */
    _finishmeasurement(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        const measuremode = this.scene.getMeasureMode();
        if (measuremode == MEASUREMODE.LEFTRIGHT) {
            if (this.scene.getCurrentGeoFrameCollection().activeimage == "right") {
                this.scene.getCurrentGeoFrameCollection().showLeftImage();
                return;
            }
        }
        this.toolstate = 1;
        if (this.snappedpos == null) {
            this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
                if (!pos.warning) {
                    this._posRequestSuccess(pos);
                }
                else {
                    this._posRequestFailed();
                }
            }, (pos) => {
                this._posRequestFailed();
            }, measuremode);
        }
        else {
            this._posRequestSuccess(this.snappedpos);
        }
    }
    _posRequestFailed() {
        this.reset();
        this.scene.getMeasureHandler().abortMeasureSequence();
    }
    _posRequestSuccess(pos) {
        this.pos = pos;
        if (pos.isValid()) {
            const res = this._measureAndDrawLR();
            if (res == null) {
                this._posRequestFailed();
                return;
            }
            const { uvwCoords, aux_line } = res;
            //Update the feature for drawing
            this.pointfeature.geometry.coordinates = [[pos.Easting, pos.Northing, pos.Height]];
            this.featurecollection.update();
            this.fire(DrawLRPointTool.finished, this.options["cbobject"], { uvwCoords, aux_line });
        }
    }
    _checkSnaping(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this.options.snaplayer && !evt.altKey) {
            const snapdataarray = this.scene.getFeatureHandler().snap(mx, my, this.options.snaplayer);
            //prevent self pickcing and filter non-pointy geometries
            for (let i = snapdataarray.length - 1; i >= 0; i--) {
                if (snapdataarray[i].geometry.type != GEOMETRYTYPE.MULTIPOINT &&
                    snapdataarray[i].geometry.type != GEOMETRYTYPE.POINT) {
                    snapdataarray.splice(i, 1);
                }
            }
            if (snapdataarray.length > 0) {
                const snapdata = snapdataarray[0];
                this.snap_mx = snapdata.found_mx;
                this.snap_my = snapdata.found_my;
                this.pos.Easting = snapdata.found_easting;
                this.pos.Northing = snapdata.found_northing;
                this.pos.Height = snapdata.found_height;
                this.pos.warning = false;
                this.snappedpos = this.pos;
            }
            else {
                this.snap_mx = null;
                this.snap_my = null;
                this.snappedpos = null;
                return this.scene
                    .getMeasureHandler()
                    .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist);
            }
            return this.pos;
        }
        else {
            return this.scene
                .getMeasureHandler()
                .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist);
        }
    }
    /**
     * removes all drawing from the scene
     * @method _cleanUp
     * @private
     */
    _cleanUp() {
        this.scene.getMeasureHandler().abortMeasureSequence();
        this.pointfeature.geometry.clear();
        this.cont_pointfeature.geometry.clear();
        this.featurecollection.update();
        this.lrVizFeature.geometry.clear();
        this.lrVizCollection.update();
    }
    /**
     * resets the tool and calls the aborted event
     * @method reset
     * @pubic
     */
    reset() {
        this.toolstate = 0;
        this._cleanUp();
        this.fire(DrawLRPointTool.reset, this.options["cbobject"]);
    }
}
DrawLRPointTool.enabled = "enabled";
DrawLRPointTool.disabled = "disabled";
DrawLRPointTool.continousdraw = "continousdraw";
DrawLRPointTool.reset = "reset";
DrawLRPointTool.finished = "finished";
DrawLRPointTool.error = "error";
//# sourceMappingURL=drawlrpointtool.js.map